import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { getFormattedDate } from '../functions/get-formatted-date';
import { FormatDateType } from '../types/format-date.type';

@Pipe({
  name: 'formatDaterangeWithSameDayCheck',
  standalone: true,
})
export class formatDaterangeWithSameDayCheck implements PipeTransform {
  transform(
    startDate: string | Date | undefined | null,
    endDate: string | Date | undefined | null,
    format: FormatDateType = 'DD.MM.YYYY',
  ): string {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    const isSameDay = start.isSame(end, 'day');

    // Return time only if the same day, otherwise the full formatted date
    return isSameDay
      ? getFormattedDate(startDate, format)
      : `${getFormattedDate(startDate, format)} - ${getFormattedDate(endDate, format)}`;
  }
}
